// 八字存档 —— localStorage 持久化（独立模块；node 测试环境可注入内存存储）
const KEY = 'bazi_saved_v1';

function store() {
  if (typeof globalThis.__baziStorage !== 'undefined' && globalThis.__baziStorage) return globalThis.__baziStorage;
  try {
    if (typeof localStorage !== 'undefined') return localStorage;
  } catch { /* jsdom 等环境访问受限 */ }
  // 兜底内存存储（仅当前进程有效）
  const mem = new Map();
  return {
    getItem: (k) => (mem.has(k) ? mem.get(k) : null),
    setItem: (k, v) => mem.set(k, v),
    removeItem: (k) => mem.delete(k),
  };
}

function load() {
  try {
    const raw = store().getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function persist(list) {
  try { store().setItem(KEY, JSON.stringify(list)); } catch { /* 容量满则忽略 */ }
}

export function listSaved() {
  // 按时间倒序；同名同盘的旧版重复记录只保留最新一条，并回写治愈存储
  const raw = load();
  const seen = new Set();
  const out = [];
  for (const r of [...raw].sort((a, b) => b.savedAt - a.savedAt)) {
    const key = `${r.name}|${r.solarText}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(r);
  }
  if (out.length !== raw.length) persist(out);
  return out;
}

/** 存档记录：{ id, name, gender, solarText, pillars, dayGan, wuxingCount, missing, shenShaNames, savedAt } */
export function saveBazi(bazi) {
  const list = load();
  const rec = {
    id: `${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    name: bazi.input.name || (bazi.solarText.slice(0, 10) + (bazi.input.gender || '')),
    gender: bazi.input.gender,
    solarText: bazi.solarText,
    pillars: bazi.pillars.map(p => ({ gan: p.gan, zhi: p.zhi })),
    dayGan: bazi.dayGan,
    wuxingCount: bazi.wuxingCount,
    missing: bazi.missing,
    shenShaNames: bazi.shenSha.map(s => s.name),
    note: '',
    city: bazi.input.city || '',
    savedAt: Date.now(),
  };
  // 同名同盘去重
  const dup = list.findIndex(x => x.name === rec.name && x.solarText === rec.solarText);
  if (dup >= 0) list.splice(dup, 1);
  list.push(rec);
  persist(list);
  return listSaved();
}

/** 编辑存档信息（姓名 / 性别 / 备注） */
export function updateSaved(id, patch) {
  const list = load();
  const rec = list.find(x => x.id === id);
  if (!rec) return listSaved();
  if (patch.name !== undefined) {
    const n = String(patch.name).trim().slice(0, 30);
    if (n) rec.name = n;
  }
  if (patch.gender === '男' || patch.gender === '女') rec.gender = patch.gender;
  if (patch.note !== undefined) rec.note = String(patch.note).slice(0, 120);
  persist(list);
  return listSaved();
}

export function deleteSaved(id) {
  const list = load().filter(x => x.id !== id);
  persist(list);
  return listSaved();
}

export function updateNote(id, note) {
  const list = load();
  const rec = list.find(x => x.id === id);
  if (rec) rec.note = String(note).slice(0, 120);
  persist(list);
  return listSaved();
}
